import React from "react";
import StartEndInfo from "./StartEndInfo";
import MovingFeeAndMenSizeInfo from "./MovingFeeAndMenSizeInfo";

export default () => {
    return (
        <>
        <StartEndInfo/>
        <MovingFeeAndMenSizeInfo/>
        </>

    )
}